import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ConfigurationPlanningService } from '../../configuration-planning.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'configuration-planning-staff-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './staff-view.part.html',
})
export class ConfigurationStaffViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(ConfigurationPlanningService);
	public setup = getSetup(this.util);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public staff = computed(() =>
		this.app.data().staff.map(s => ({ ...s, updatedUTC: Date.now() }))
	);

}